document.querySelectorAll("#product-form-visible").forEach((element) => {
	let footerCheckout = document.getElementById("product-form-visible").querySelector(".product-sticky-add-to-cart");
	new Waypoint({
		element: element,
		handler: function (direction) {
			if (direction == "down") {
				footerCheckout.classList.add("active");
			} else {
				footerCheckout.classList.remove("active");
			}
		},
	});
});
